var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8511 6.08511C14.8511 8.34125 13.0221 10.1702 10.766 10.1702C8.50982 10.1702 6.68085 8.34125 6.68085 6.08511C6.68085 3.82896 8.50982 2 10.766 2C13.0221 2 14.8511 3.82896 14.8511 6.08511ZM13.4184 11.5632C15.4502 10.5776 16.8511 8.49497 16.8511 6.08511C16.8511 2.7244 14.1267 0 10.766 0C7.40525 0 4.68085 2.7244 4.68085 6.08511C4.68085 8.49497 6.08171 10.5776 8.11352 11.5632C4.08379 12.5842 0.95984 15.8777 0.185422 20C0.0636773 20.6481 0 21.3166 0 22H2H19.5319H21.5319C21.5319 21.3166 21.4682 20.6481 21.3465 20C20.5721 15.8777 17.4481 12.5842 13.4184 11.5632ZM2.22919 20C3.13408 16.1224 6.61271 13.234 10.766 13.234C14.9192 13.234 18.3978 16.1224 19.3027 20H2.22919Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon-user.e12806bf38c0e6e41e448275bcb3844d.svg";
export { ForwardRef as ReactComponent };